export default function CDoWhile() {
  return <h2>C Do While</h2>;
}
